import { render } from "./MyastheniaGravisView.vue?vue&type=template&id=0de9dea8"
import script from "./MyastheniaGravisView.vue?vue&type=script&lang=js"
export * from "./MyastheniaGravisView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__